import styled from '@emotion/styled';

export const Container = styled.div({
  alignItems: 'center',
  backgroundColor: 'transparent',
  borderRadius: '8px',
  display: 'flex',
  height: 'max-content',
  justifyContent: 'center',
});
